/* eslint-disable @typescript-eslint/no-unused-vars */
export enum SocialProvider {
	Google = 'google',
	Apple = 'apple',
	Facebook = 'facebook',
	Email = 'email',
	Mobile = 'mobile'
}
